/* UltraClean Pro — modules de vente UC3 :
   hero sélecteur de taille, outil « ça rentre ? », réglages conseillés, barre d'achat collante,
   assistant de choix, ajout rapide, comparateur. Aucune dépendance. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ----------------------------------------------------- utilitaires panier */
  function toast(title) {
    var t = $('[data-uc3-toast]');
    if (!t) return;
    $('[data-uc3-toast-title]', t).textContent = title;
    t.classList.add('is-on');
    clearTimeout(toast.k);
    toast.k = setTimeout(function () { t.classList.remove('is-on'); }, 6000);
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-uc2-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return cart;
      });
  }

  /* ------------------------------------------------------ hero : tailles */
  $$('[data-uc3-hero]').forEach(function (hero) {
    var box = $('[data-uc3-hero-chips]', hero);
    if (!box) return;
    var chips = $$('[data-uc3-hero-chip]', box);
    chips.sort(function (a, b) { return (+a.dataset.vol || 999) - (+b.dataset.vol || 999); }).forEach(function (c) { box.appendChild(c); });
    var imgs = $$('[data-uc3-hero-img]', hero), sel = $('[data-uc3-hero-sel]', hero);
    function pick(c) {
      chips.forEach(function (x) { x.classList.toggle('is-on', x === c); x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      imgs.forEach(function (im) { im.classList.toggle('is-on', im.dataset.uc3HeroImg === c.dataset.uc3HeroChip); });
      $('[data-uc3-hero-name]', hero).textContent = c.dataset.name;
      $('[data-uc3-hero-price]', hero).textContent = c.dataset.price;
      sel.href = c.dataset.url;
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });
    var start = chips.filter(function (c) { return +c.dataset.vol === 10; })[0] || chips[0];
    if (start) pick(start);
  });

  /* ------------------------------------------- galerie : compteur de photo */
  $$('[data-uc3-gallery]').forEach(function (g) {
    var n = $('[data-uc3-slide-n]', g);
    if (!n) return;
    var slides = $$('[data-uc3-slide]', g);
    new MutationObserver(function () {
      var i = slides.findIndex(function (s) { return s.classList.contains('is-on'); });
      n.textContent = ('0' + (i + 1)).slice(-2);
    }).observe(g, { subtree: true, attributes: true, attributeFilter: ['class'] });
  });

  /* ---------------------------------------------- barre d'achat collante */
  var bar = $('[data-uc3-bar]'), cta = $('[data-uc3-main-cta]');
  if (bar && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      $$('a,button', bar).forEach(function (b) { b.tabIndex = past ? 0 : -1; });
    }).observe(cta);
  }

  /* ------------------------------------------- outil « ça rentre ? » */
  $$('[data-uc3-fit]').forEach(function (sec) {
    var dims = function (s) { return (s || '').split(',').map(Number).filter(function (n) { return n > 0; }); };
    var basket = dims(sec.dataset.panier), tank = dims(sec.dataset.cuve), isBasket = basket.length === 3;
    var box = isBasket ? basket : tank;
    if (box.length !== 3) { sec.hidden = true; return; }
    sec.classList.add('is-ready');
    var inputs = $$('[data-fit]', sec), svg = $('[data-fit-svg]', sec), verdict = $('[data-fit-verdict]', sec), legend = $('[data-fit-legend]', sec);
    var marg = isBasket ? 0 : 15; /* sans panier : on garde 15 mm de marge avec les parois */
    var B = box.map(function (v) { return v - marg; });
    function draw() {
      var P = inputs.map(function (i) { return Math.max(1, +i.value || 1); });
      var ps = P.slice().sort(function (a, b) { return b - a; }), bs = B.slice(0, 2).sort(function (a, b) { return b - a; });
      /* la pièce peut être tournée : on la pose sur sa plus grande face, la hauteur est sa plus petite dimension */
      var fitsLen = ps[0] <= bs[0], fitsWid = ps[1] <= bs[1], fitsH = ps[2] <= B[2];
      var ok = fitsLen && fitsWid && fitsH;
      var W = 340, H = 220, sc = Math.min(W / Math.max(bs[0], ps[0]), H / Math.max(bs[1], ps[1]));
      var bw = bs[0] * sc, bh = bs[1] * sc, pw = ps[0] * sc, ph = ps[1] * sc;
      var ox = (400 - bw) / 2, oy = (300 - bh) / 2;
      var grid = '';
      for (var x = 12; x < bw; x += 12) grid += '<line x1="' + (ox + x) + '" y1="' + oy + '" x2="' + (ox + x) + '" y2="' + (oy + bh) + '"/>';
      for (var y = 12; y < bh; y += 12) grid += '<line x1="' + ox + '" y1="' + (oy + y) + '" x2="' + (ox + bw) + '" y2="' + (oy + y) + '"/>';
      svg.innerHTML =
        '<rect class="b" x="' + ox + '" y="' + oy + '" width="' + bw + '" height="' + bh + '" rx="6"/>' +
        '<g class="g">' + grid + '</g>' +
        '<rect class="p ' + (ok ? 'ok' : 'ko') + '" x="' + ((400 - pw) / 2) + '" y="' + ((300 - ph) / 2) + '" width="' + pw + '" height="' + ph + '" rx="8"/>' +
        '<text x="200" y="' + (oy - 10) + '" text-anchor="middle">' + (isBasket ? 'Panier' : 'Cuve') + ' ' + B[0] + ' × ' + B[1] + ' mm</text>' +
        '<text x="200" y="' + (oy + bh + 22) + '" text-anchor="middle">Hauteur utile ' + B[2] + ' mm · votre pièce ' + ps[2] + ' mm</text>';
      if (ok) {
        verdict.className = 'uc3-fit__verdict is-ok';
        verdict.innerHTML = '<b>Elle rentre.</b> Il reste ' + (bs[0] - ps[0]) + ' mm en longueur et ' + (B[2] - ps[2]) + ' mm en hauteur.';
      } else {
        var why = !fitsH ? 'trop haute pour être immergée' : !fitsLen ? 'trop longue' : 'trop large';
        verdict.className = 'uc3-fit__verdict is-ko';
        verdict.innerHTML = '<b>Trop juste : pièce ' + why + '.</b> <a href="' + sec.dataset.catalogue + '?taille=' + (ps[0] <= 330 && ps[2] <= 180 ? '7-15' : '16-999') + '">Voir les cuves plus grandes →</a>';
      }
      legend.textContent = isBasket ? 'Vue de dessus, à l’échelle. La pièce peut être tournée.' : 'Dimensions intérieures de la cuve, marge de 15 mm aux parois.';
    }
    inputs.forEach(function (i) { i.addEventListener('input', function () { $$('.uc3-chip', sec).forEach(function (c) { c.classList.remove('is-on'); }); draw(); }); });
    $$('[data-dims]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var d = b.dataset.dims.split(',');
        inputs.forEach(function (i, k) { i.value = d[k]; });
        $$('[data-dims]', sec).forEach(function (c) { c.classList.toggle('is-on', c === b); });
        draw();
      });
    });
    draw();
  });

  /* --------------------------------------------- réglages conseillés */
  $$('[data-uc3-set]').forEach(function (sec) {
    var tabs = $$('[role="tab"]', sec), dials = $$('[data-dial]', sec), liq = $('[data-liq-out]', sec), deg = $('[data-deg-out]', sec);
    function show(b) {
      tabs.forEach(function (t) { t.classList.toggle('is-on', t === b); t.setAttribute('aria-selected', t === b ? 'true' : 'false'); });
      dials.forEach(function (d) {
        var v = +b.dataset[d.dataset.dial], max = +d.dataset.max;
        var arc = $('.val', d), out = $('[data-v]', d), from = +out.textContent || 0, t0 = performance.now();
        arc.style.strokeDasharray = (v / max * 100) + ' 100';
        (function step(now) {
          var k = Math.min(1, (now - t0) / 700), e = 1 - Math.pow(1 - k, 3);
          out.textContent = Math.round(from + (v - from) * e);
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      });
      liq.textContent = b.dataset.liq;
      deg.hidden = b.dataset.deg !== '1';
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
    if (tabs[0]) show(tabs[0]);
  });

  /* ----------------------------------------------------- ajout rapide */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-uc3-quick]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var txt = b.textContent;
    b.disabled = true; b.textContent = '…';
    addToCart(b.dataset.uc3Quick, 1)
      .then(function () { b.textContent = 'Ajouté ✓'; b.classList.add('is-done'); toast(b.dataset.title); })
      .catch(function () { b.textContent = 'Indisponible'; })
      .then(function () { setTimeout(function () { b.disabled = false; b.textContent = txt; b.classList.remove('is-done'); }, 2200); });
  });

  /* ------------------------------------------------------- assistant */
  $$('[data-uc3-quiz]').forEach(function (q) {
    var steps = $$('.uc3-quiz__step', q), dots = $$('.uc3-quiz__dots i', q), res = $('[data-quiz-res]', q), picks = $('[data-quiz-picks]', q);
    var ans = {};
    function go(i) {
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k <= i); });
      res.hidden = i < steps.length;
    }
    steps.forEach(function (s, i) {
      $$('button', s).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', s).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          ans[s.dataset.q] = +b.dataset.v;
          if (i < steps.length - 1) go(i + 1); else finish();
        });
      });
    });
    function finish() {
      var need = Math.max(ans.piece || 0, ans.size || 0);
      var cards = $$('[data-uc3-card]').filter(function (c) { return !c.hidden || true; });
      var fit = cards.filter(function (c) { return (+c.dataset.vol || 0) >= need; });
      fit.sort(function (a, b) { return (+a.dataset.vol) - (+b.dataset.vol) || pr(a) - pr(b); });
      /* usage intensif : on préfère la série à puissance réglable */
      if (ans.use === 2) fit.sort(function (a, b) { return score(b) - score(a) || (+a.dataset.vol) - (+b.dataset.vol); });
      var top = fit.slice(0, 2);
      picks.innerHTML = '';
      if (!top.length) {
        picks.innerHTML = '<p class="uc3-quiz__none">Aucun modèle de cette page ne convient. <a href="/collections/catalogue">Voir toute la gamme</a> ou <a href="/pages/contact">demandez-nous conseil</a>.</p>';
      }
      top.forEach(function (c, k) {
        var a = document.createElement('a');
        a.className = 'uc3-quiz__pick';
        a.href = c.dataset.url;
        a.innerHTML = '<img src="' + c.dataset.img + '" alt="" loading="lazy"><span><small class="uc2-label">' + (k === 0 ? 'Le plus adapté' : 'Alternative') + '</small><b>' + c.dataset.name + '</b><em>' + c.dataset.priceTxt + '</em></span>';
        picks.appendChild(a);
      });
      $$('[data-uc3-card]').forEach(function (c) { c.classList.toggle('is-pick', top.indexOf(c) > -1); });
      go(steps.length);
      res.hidden = false;
      steps.forEach(function (s) { s.classList.remove('is-on'); });
    }
    function pr(c) { var v = +c.dataset.price; return v === 0 ? 1e12 : v; }
    function score(c) { return /serie-x/.test(c.dataset.handle) ? 2 : /serie-w/.test(c.dataset.handle) ? 1 : 0; }
    $('[data-quiz-restart]', q).addEventListener('click', function () {
      ans = {}; $$('button.is-on', q).forEach(function (b) { b.classList.remove('is-on'); });
      $$('[data-uc3-card]').forEach(function (c) { c.classList.remove('is-pick'); });
      go(0);
    });
  });

  /* ------------------------------------------------------- comparateur */
  var cbar = $('[data-uc3-cbar]');
  if (cbar) {
    var items = $('[data-uc3-cbar-items]', cbar), modal = $('[data-uc3-cmodal]'), body = $('[data-uc3-cmodal-body]');
    var chosen = [];
    function sync() {
      cbar.hidden = chosen.length === 0;
      items.innerHTML = chosen.map(function (c) { return '<img src="' + c.dataset.img + '" alt="' + c.dataset.name + '" title="' + c.dataset.name + '">'; }).join('') + '<span class="uc2-label">' + chosen.length + ' / 3</span>';
      $('[data-uc3-cbar-open]', cbar).disabled = chosen.length < 2;
      $$('[data-uc3-cmp-toggle]').forEach(function (t) { t.checked = chosen.indexOf(t.closest('[data-uc3-card]')) > -1; });
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-uc3-cmp-toggle]')) return;
      var card = t.closest('[data-uc3-card]');
      var i = chosen.indexOf(card);
      if (t.checked && i < 0) { if (chosen.length >= 3) chosen.shift(); chosen.push(card); }
      if (!t.checked && i > -1) chosen.splice(i, 1);
      sync();
    });
    $('[data-uc3-cbar-clear]', cbar).addEventListener('click', function () { chosen = []; sync(); });
    $('[data-uc3-cbar-open]', cbar).addEventListener('click', function () {
      var specs = chosen.map(function (c) { try { return JSON.parse(c.dataset.specs); } catch (e) { return {}; } });
      var keys = Object.keys(specs[0] || {});
      var h = '<table class="uc3-cmp__table uc3-cmp__table--cols"><thead><tr><th></th>' + chosen.map(function (c) { return '<th><a href="' + c.dataset.url + '"><img src="' + c.dataset.img + '" alt=""><span>' + c.dataset.name + '</span></a></th>'; }).join('') + '</tr></thead><tbody>';
      keys.forEach(function (k) {
        var vals = specs.map(function (s) { return s[k] || '—'; });
        var diff = vals.some(function (v) { return v !== vals[0]; });
        h += '<tr class="' + (diff ? 'is-diff' : '') + '"><th scope="row">' + k + '</th>' + vals.map(function (v) { return '<td>' + v + '</td>'; }).join('') + '</tr>';
      });
      h += '<tr><th scope="row">Prix</th>' + chosen.map(function (c) { return '<td><b>' + c.dataset.priceTxt + '</b></td>'; }).join('') + '</tr></tbody></table>';
      body.innerHTML = h;
      if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
    });
    $('[data-uc3-cmodal-close]').addEventListener('click', function () { modal.close ? modal.close() : modal.removeAttribute('open'); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
  }

  /* filtre « ?taille= » venu de l'outil « ça rentre ? » */
  var m = /[?&]taille=([0-9]+-[0-9]+)/.exec(location.search);
  if (m) {
    var fb = $('[data-uc3-filter="' + m[1] + '"]');
    if (fb) setTimeout(function () { fb.click(); fb.scrollIntoView({ block: 'center' }); }, 400);
  }
})();
/* ------------------------------------------- menus déroulants du header */
(function () {
  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-uc3-mega]'));
  if (!triggers.length) return;
  var panels = {};
  Array.prototype.forEach.call(document.querySelectorAll('[data-uc3-mega-panel]'), function (p) { if (!panels[p.dataset.uc3MegaPanel]) panels[p.dataset.uc3MegaPanel] = p; });
  var open = null, timer = 0;
  function show(name) {
    clearTimeout(timer);
    Object.keys(panels).forEach(function (k) { var on = k === name; panels[k].hidden = !on; panels[k].classList.toggle('is-on', on); });
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', t.dataset.uc3Mega === name ? 'true' : 'false'); });
    open = name;
  }
  function hideSoon() { clearTimeout(timer); timer = setTimeout(function () { show(null); }, 220); }
  var fine = window.matchMedia('(hover: hover)').matches;
  triggers.forEach(function (t) {
    if (fine) t.addEventListener('mouseenter', function () { show(t.dataset.uc3Mega); });
    t.addEventListener('mouseleave', hideSoon);
    t.addEventListener('click', function (e) {
      if (!fine || open !== t.dataset.uc3Mega) { e.preventDefault(); show(open === t.dataset.uc3Mega ? null : t.dataset.uc3Mega); }
    });
  });
  Object.keys(panels).forEach(function (k) {
    panels[k].addEventListener('mouseenter', function () { clearTimeout(timer); });
    panels[k].addEventListener('mouseleave', hideSoon);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') show(null); });
  document.addEventListener('click', function (e) { if (open && !e.target.closest('[data-uc3-mega],[data-uc3-mega-panel]')) show(null); });
  window.addEventListener('scroll', function () { if (open) show(null); }, { passive: true });
})();
